import { chakra } from '@stockx/ui';

export const SubMenuWrapper = chakra('div', {
  baseStyle: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
    height: '100%',
    webkitOverflowScrolling: 'touch',

    '&.activeSubMenu': {
      overflowY: 'scroll',
    },
  },
});
